import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { headerConstants } from '../../redux/header/header.constants';
import { errorConstants } from '../../redux/error/error.constants';

function HeaderComponent() { 
    const [devicesSelector, errorReducer, headerReducer] = useSelector(state => [state.deviceReducer, state.errorReducer, state.headerReducer]);

    useEffect(() => {
        // Dynamically calculate header height and set CSS custom property for wrapper-body padding
        const updateHeaderHeight = () => {
            const headerWrapper = document.querySelector('.header-wrapper');
            const wrapperBody = document.getElementById('warpper-body');
            
            if (headerWrapper && wrapperBody) {
                const headerHeight = headerWrapper.offsetHeight;
                const transitionHeight = 30; // Transition div height
                const spacing = 0; // Additional spacing if needed
                
                // Set CSS custom property on root for wrapper-body to use
                document.documentElement.style.setProperty('--header-wrapper-height', `${headerHeight + transitionHeight + spacing}px`);
                
                // Also set padding-top directly on wrapper-body
                wrapperBody.style.paddingTop = `${headerHeight + transitionHeight + spacing}px`;
            }
        };
        
        // Update on mount and when content changes
        updateHeaderHeight();
        
        // Use ResizeObserver to update when header height changes
        const headerWrapper = document.querySelector('.header-wrapper');
        if (headerWrapper && window.ResizeObserver) {
            const resizeObserver = new ResizeObserver(() => {
                updateHeaderHeight();
            });
            resizeObserver.observe(headerWrapper);
            
            return () => {
                resizeObserver.disconnect();
            };
        }
        
        // Fallback: Update on window resize
        window.addEventListener('resize', updateHeaderHeight);
        
        return () => {
            window.removeEventListener('resize', updateHeaderHeight);
        };
    }, [devicesSelector, errorReducer, headerReducer])

    const getStoreName = () => {
        if (devicesSelector.deviceDetail?.friendlyName != null) {
            return devicesSelector.deviceDetail?.friendlyName;
        } else {
            return devicesSelector.storeDetail?.name;
        }
    }

    const headerWithGreet = () => {
        let isError = (errorReducer.name === errorConstants.SET_ERROR || errorReducer.name === errorConstants.SET_ERROR_API) && errorReducer.isActive === true;
        if (isError) {
            return headerError();
        } else {
            return (
                <div className="header-wrapper">
                    <div id="header">
                        <h4>Velkommen til</h4>
                        <h4>{Object.keys(devicesSelector.storeDetail).length > 0 ? devicesSelector.storeDetail?.adress + " , " + devicesSelector.storeDetail?.city : ''}</h4>
                        <h2>{getStoreName()}</h2>
                    </div>
                    <div className="header-transition"></div>
                </div>
            );
        }
    }

    const headerError = () => {
        return (
            <div className="header-wrapper">
                <div id="header">
                    <h4>Velkommen til</h4>
                </div>
                <div className="header-transition"></div>
            </div>
        );
    }

    const header = () => {
        let isError = (errorReducer.name === errorConstants.SET_ERROR || errorReducer.name === errorConstants.SET_ERROR_API) && errorReducer.isActive === true;
        if (isError) {
            return headerError();
        }
        return (
            <div className="header-wrapper">
                <div id="header">
                    <h2> {getStoreName()}</h2>
                </div>
                <div className="header-transition"></div>
            </div>
        );
    }

    return (
        headerReducer.name === headerConstants.SET_HEADER_GREET && headerReducer.isActive === true
            ?
            headerWithGreet()
            :
            header()
    );
}

export { HeaderComponent };